import { isElement, forEach } from 'lodash';

const
    moduleName = 'blueconic',
    selectors = {
        base: `.js-${moduleName}`,
        consent: `.js-${moduleName}-consent`,
        bcConsentButton: '.bcGiveConsent'
    },
    dataset = {
        src: `src`
    },
    classname = {
        consent: 'consent-given'
    },
    PERMISSIONLEVEL = {
        FULL_PERMISSION: 'volledig_wandel_nl__1',
        FUNCTIONAL_PERMISSION: 'functioneel_wandel_nl__1'
    };

export class BlueConic {
    constructor(element) {
        if (!isElement(element)) {
            return false;
        }

        this._config(element);
        this._bindEvents();
    }

    _checkConsent() {
        const profile = window.blueConicClient.profile.getProfile();

        if (profile.getConsentedObjectives().includes(PERMISSIONLEVEL.FULL_PERMISSION)) {
            // show videos
            forEach(this.consentElements, (consent) => {
                consent.classList.add(classname.consent);
            });
            this._setSource();
        } else {
            // hide videos
            this._removeSource();
            forEach(this.consentElements, (consent) => {
                consent.classList.remove(classname.consent);
            })
        }
        
    }

    _setSource() {
        const source = this.baseElement?.dataset[dataset.src];
        this.baseElement.setAttribute('src', source);
    }

    _removeSource() {
        this.baseElement.removeAttribute('src');
    }

    
    _bindEvents() {
        if (typeof window.blueConicClient !== 'undefined' &&
            typeof window.blueConicClient.event !== 'undefined' &&
            typeof window.blueConicClient.event.subscribe !== 'undefined') {
            // BlueConic is loaded, now we can do API things
            this._checkConsent();
        } else {
            // Not yet loaded; wait for the "onBlueConicLoaded" event
            window.addEventListener('onBlueConicLoaded', () => this._checkConsent(), false);
        }
    }

    _config(element) {
        this.baseElement = element;
        this.consentElements = document.querySelectorAll(selectors.consent);
    }
}

function initBlueConic(elements = document.querySelectorAll(selectors.base)) {
    forEach(elements, element => {
        new BlueConic(element);
    });
}

initBlueConic();